module.exports = __webpack_public_path__ + "img/5f_r_iso.f88fcc9b.png";